import { useQuery } from "react-query";
import { PagedRequestType } from "../types/PagedResults";
import { getScholarshipProviders } from "../services/school/scholarshipProvider";
import { key_ScholarshipProviders } from "../utils/constants";

export const useGetScholarshipProvidersQuery = (data: PagedRequestType, options:any = null) => {
    return useQuery([key_ScholarshipProviders, JSON.stringify(data)], () => getScholarshipProviders(data),    options?{...options}:{}
);
};
